import { INTERNSHIP_APP_API } from '../Config/config';

const updateReportApi = (
  WorkLogId: string | number,
  EntryId: React.Key
): string => {
  return `${INTERNSHIP_APP_API}/worklogs/${WorkLogId}/entries/${EntryId}/reject-note`;
};

const validateWorkReportByTutor = (
  organizationId: string | number,
  processId: string | number,
  tutorId: string | number
): string => {
  return `${INTERNSHIP_APP_API}/organizations/${organizationId}/internship-processes/${processId}/tutors/${tutorId}/validate`;
};

const rejectReportByTutor = (worklogId: string | number): string => {
  return `${INTERNSHIP_APP_API}/worklogs/${worklogId}/reject-reports`;
};

export { updateReportApi, validateWorkReportByTutor, rejectReportByTutor };
